import { useEffect, useState, Fragment } from "react";
import CreateList from "./CreateList";

export default function CreateListGroup({data, moreInfoSetData, type}){
    const [listItems, updateListItems] = useState({});
    const siftData = () => {
      let tempArray = {};
      data.forEach((item, index) => {
        let brand = item.Brand;
        if (tempArray[brand] === undefined){
          tempArray[brand] = [item]
        } else {
          tempArray[brand].push(item);
        }
      });
      updateListItems(tempArray);
    }
  
    useEffect(()=>{
      siftData();
    }, []);
    
    const listItemsArray = Object.keys(listItems).map((element,index) => {
      return <CreateList key={index} brand={element} type={type} data={listItems[element]} moreInfoSetData={moreInfoSetData}/>
    })
    const halfArray = () => {
      const halfWayIndex = Math.ceil(listItemsArray.length / 2)
      return [listItemsArray.splice(0, halfWayIndex), listItemsArray.splice(0, listItemsArray.length)]
    }
    const trueArray = halfArray()
    return (
      <Fragment>
        <ul>
          {trueArray[0]}
        </ul>
        <ul>
          {trueArray[1]}
        </ul>
      </Fragment>
    )
  }